import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import axios from 'axios';
import './EditOfferModal.css';
import { postData } from '../../../services/apiServices';
import { useSelector } from 'react-redux';
import Loader from '../Loader/Loader';
import toastService from '../../../services/toastService';

const EditOfferModal = ({ isOpen, onClose, offerId, offerData }) => {
    const [formData, setFormData] = useState({
        PropertyName: '',
        Location: '',
        Price: '',
        PropertyStatus: '',
        Status: '',
        Description: '',
        DeveloperName: '',
        District: '',
        NumberOfRooms: '',
        Area: '',
        Neighborhood: '',
        ContactNumber: '',
        Pictures: [],
        PropertyType: ''
    });
    const [isFeatured, setIsFeatured] = useState(null)
    const [loading, setLoading] = useState(false)

    const userInfo = useSelector((state) => state.user.userInfo);
     useEffect(() => {
        if (offerData) {
            setFormData({
                PropertyName: offerData.PropertyName,
                Location: offerData.Location,
                Price: offerData.Price,
                PropertyStatus: offerData.PropertyStatus,
                Status: offerData.Status,
                Description: offerData.Description,
                DeveloperName: offerData.DeveloperName,
                NumberOfRooms: offerData.NumberOfRooms,
                Area: offerData.Area,
                Neighborhood: offerData.Neighborhood,
                ContactNumber: offerData.ContactNumber,
                District: offerData.District,
                PropertyType: offerData.PropertyType,
                Pictures: offerData.Pictures
                    ? offerData.Pictures.split(',').map(url => url.replace(/"/g, '').trim())
                    : [],
            });
            setIsFeatured(offerData.is_featured == 1 ? true : false || null);

        }
    }, [offerData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

   
    const handleImageChange = async (event) => {
        const file = event.target.files[0];
        if (!file) {
            toastService.showError('No image selected');
            return;
        }
    
        // Creating a FormData object to send the image
        const formData = new FormData();
        formData.append('verification_token', '123456');
        formData.append('files_upload', file);  
    
        try {
            const response = await fetch('https://appvelo.com/realestateOfferAPI/fileupload', {
                method: 'POST',
                body: formData,
            });
    
            const result = await response.json();
            if (result.message === 'success' && result.url) {
                setFormData((prevData) => ({
                    ...prevData,
                    Pictures: [...prevData.Pictures, result.url], // Ensure you're using the correct state
                }));
                toastService.showSuccess('Image uploaded successfully');
            } else {
                toastService.showError(result.message || 'Image upload failed');
            }
        } catch (error) {
            console.error('Error uploading image:', error);
            toastService.showError('Image upload failed');
        }
    };
    

    const handleImageRemove = (index) => {
        setFormData({
            ...formData,
            Pictures: formData.Pictures.filter((_, i) => i !== index)
        });
    };

    const handleSubmit = async () => {
        const formattedImages = JSON.stringify(formData.Pictures).replace(/^\[|\]$/g, "");
        setLoading(true)
        const datas = {
            verification_token: "123456",
            table: "property_offers",
            id: offerData?.id,
            offerid: offerData?.OfferID,
            Area: formData.Area,
            ContactNumber: formData.ContactNumber,
            CreatedByID: userInfo?.id,
            Description: formData.Description,
            DeveloperName: formData.DeveloperName,
            District: formData.District,
            IsArchived: "0",
            Location: formData.Location,
            Neighborhood: formData.Neighborhood,
            NumberOfRooms: formData.NumberOfRooms,
            OfferID: offerData?.OfferID,
            Price: formData.Price,
            PropertyName: formData.PropertyName,
            PropertyStatus: formData.PropertyStatus,
            PropertyType: formData.PropertyType,
            RelatedOfferID: offerData?.RelatedOfferID,
            Status: formData.Status,
            Pictures: formattedImages,
            Is_Featured: isFeatured === true ? 1 : 0
        };

        try {

            const response = await postData('/edit', datas);

            console.log(response, "API response after submission");

            if (response?.message === "success") {
                toastService.showSuccess("Edit Successful");
                setLoading(false)

                // If the status is inactive, navigate to a different screen
                if (response?.data?.Status === "inactive") {
                    window.location.href = '/latest-properties';
                }
                onClose();
            } else {
                toastService.showError("Offer not edited. Please try again.");
                setLoading(false)

            }
        } catch (error) {
            setLoading(false)
            console.error("Error submitting the form", error);
            toastService.showError("Something went wrong. Please try again later.");
        }
    };

    return (
        <>
            <Modal isOpen={isOpen} onRequestClose={onClose} contentLabel="Edit Offer"
                style={{
                    overlay: {
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(0, 0, 0, 0.75)'
                    },
                    content: {
                        width: '600px',
                        maxHeight: '80vh', // Set maximum height for the modal content
                        margin: 'auto',
                        borderRadius: '8px',
                        padding: '20px',
                        overflowY: 'auto', // Allow scrolling when content exceeds maxHeight
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                        position: 'relative'
                    }
                }}
            >
                <Loader isLoading={loading} />

                <h2>Edit Offer</h2>
                <div className="form-group">
                    <label>Property Name</label>
                    <input
                        type="text"
                        name="PropertyName"
                        value={formData.PropertyName}
                        onChange={handleInputChange}
                    />
                </div>
                <div className="form-group">
                    <label>Location</label>
                    <input
                        type="text"
                        name="Location"
                        value={formData.Location}
                        onChange={handleInputChange}
                        className='text-inputs'
                    />
                </div>


                <div className="form-group">
                    <label>Developer Name</label>
                    <input
                        type="text"
                        name="DeveloperName"
                        value={formData.DeveloperName}
                        onChange={handleInputChange}
                        className='text-inputs'
                    />
                </div>

                <div className="form-group">
                    <label>District</label>
                    <input
                        type="text"
                        name="District"
                        value={formData.District}
                        onChange={handleInputChange}
                        className='text-inputs'
                    />
                </div>

                <div className="form-group">
                    <label>Phone Number</label>
                    <input
                        type="text"
                        name="ContactNumber"
                        value={formData.ContactNumber}
                        onChange={handleInputChange}
                        className='text-inputs'
                    />
                </div>

                <div className="form-group">
                    <label>NeighborHood</label>
                    <input
                        type="text"
                        name="Neighborhood"
                        value={formData.Neighborhood}
                        onChange={handleInputChange}
                        className='text-inputs'
                    />
                </div>

                <div className="form-group">
                    <label>Area</label>
                    <input
                        type="text"
                        name="Area"
                        value={formData.Area}
                        onChange={handleInputChange}
                        className='text-inputs'
                    />
                </div>

                <div className="form-group">
                    <label>Number Of Rooms</label>
                    <input
                        type="text"
                        name="NumberOfRooms"
                        value={formData.NumberOfRooms}
                        onChange={handleInputChange}
                        className='text-inputs'
                    />
                </div>



                <div className="form-group">
                    <label>Price</label>
                    <input
                        type="text"
                        name="Price"
                        value={formData.Price}
                        onChange={handleInputChange}
                        className='text-inputs'
                    />
                </div>


                <div className="input-field">
                    <div className="input-wrapper">
                        <label className="input-title">Is Featured?</label>
                        <div className="button-group">
                            <button
                                type="button"
                                className={`feature-button ${isFeatured === true ? 'selected' : ''}`}
                                onClick={() => setIsFeatured(true)}
                            >
                                Yes
                            </button>
                            <button
                                type="button"
                                className={`feature-button ${isFeatured === false ? 'selected' : ''}`}
                                onClick={() => setIsFeatured(false)}
                            >
                                No
                            </button>
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <label>Property Type</label>
                    <select name="PropertyType" value={formData.PropertyType} onChange={handleInputChange}>
                        <option value="appartment">appartment</option>
                        <option value="villa">villa</option>
                        <option value="land">land</option>
                        <option value="extension">extension</option>

                    </select>
                </div>

                <div className="form-group">
                    <label>Property Status</label>
                    <select name="PropertyStatus" value={formData.PropertyStatus} onChange={handleInputChange}>
                        <option value="Ready">Ready</option>
                        <option value="Under construction">Under construction</option>
                    </select>
                </div>
                <div className="form-group">
                    <label>Status</label>
                    <select name="Status" value={formData.Status} onChange={handleInputChange}>
                        <option value="active">Active</option>
                        <option value="sold">Inactive</option>
                    </select>
                </div>
                <div className="form-group">
                    <label>Images</label>
                    <input type="file" multiple onChange={handleImageChange} />
                    <div className="image-preview">
                        {formData.Pictures.map((image, index) => (
                            <div key={index} className="image-container">
                                <img src={image} alt={`img-${index}`} />
                                <button className="remove-btn" onClick={() => handleImageRemove(index)}>    <i className="fa fa-times" aria-hidden="true"></i> {/* Font Awesome cross icon */}
                                </button>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="input-field">
                    <div className="input-wrapper">
                        <label className='input-title'>Offer Detail</label>
                        <textarea
                            type="text"
                            name="Description"
                            placeholder="Enter Offer Detail"
                            value={formData.Description}
                            onChange={handleInputChange}
                            required
                            className="textarea"

                        />
                    </div>
                </div>
                <button className="submit-btn" onClick={handleSubmit}>Submit</button>
            </Modal>
        </>
    );
};

export default EditOfferModal;
